export enum AcceptanceAction {
  ACCEPTANCE_ACTION_UNKNOWN = 'ACCEPTANCE_ACTION_UNKNOWN',
  CHECK_OFF_BOX = 'CHECK_OFF_BOX',
  ENROLMENT = 'ENROLMENT',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
}
